export interface NavItem {
  label: string;
  href: string;
  badge?: string;
  icon?: string;
  description?: string;
  items?: NavItem[];
}

export interface NavSection {
  label: string;
  href?: string;
  icon?: string;
  items?: NavItem[];
  description?: string;
}

export const mainNavigation: NavSection[] = [
  { label: "Jobs", href: "/jobs" },
  { label: "Advanced Job Search", href: "/search" },
  {
    label: "Partner Jobs ↗",
    href: "https://www.profitableratecpmnetwork.com/ft1utmwkf?key=06e9abe562b34cccc29b85b19d5dfd83",
    icon: "🔥",
    description: "Explore featured partner job listings and opportunities",
  },
  {
    label: "Blog",
    href: "/blog",
    icon: "📝",
    description: "Career insights and expert advice",
  },
  {
    label: "Community",
    icon: "👥",
    description: "Connect with professionals",
    items: [
      {
        label: "Forums",
        href: "/community/questions",
        icon: "💬",
        description: "Join the conversation",
        items: [
          { label: "Community Q&A", href: "/community/questions", icon: "❓" },
          { label: "Ask a Question", href: "/community/questions", icon: "➕" },
          { label: "Industry Chat", href: "/community/questions", icon: "🏭" },
          { label: "Job Search Help", href: "/community/questions", icon: "🆘" },
          { label: "Tech Talk", href: "/community/questions", icon: "💻" },
          { label: "Salary Discussions", href: "/community/questions", icon: "💰" },
        ]
      },
      {
        label: "Events",
        href: "/community",
        icon: "📅",
        description: "Webinars & meetups",
        items: [
          { label: "Upcoming Events", href: "/community", icon: "📅" },
          { label: "Webinars", href: "/community", icon: "📹" },
          { label: "Job Fairs", href: "/community", icon: "🎪" },
        ]
      },
    ],
  },
];

export interface FooterSection {
  title: string;
  links: { label: string; href: string }[];
}

export const footerNavigation: FooterSection[] = [
  {
    title: "For Job Seekers",
    links: [
      { label: "Search Jobs", href: "/jobs" },
      { label: "Partner Job Offers ↗", href: "https://www.profitableratecpmnetwork.com/ft1utmwkf?key=06e9abe562b34cccc29b85b19d5dfd83" },
      { label: "Career Advice", href: "/blog" },
      { label: "Resume Writing", href: "/blog" },
      { label: "Resume Builder", href: "/profile" },
      { label: "Featured Profile", href: "/profile" },
      { label: "Interview Preparation", href: "/blog" },
    ],
  },
  {
    title: "For Employers",
    links: [
      { label: "Free Post a Job", href: "/post-job" },
      { label: "Resume Database Access", href: "/search" },
      { label: "Hiring Solutions", href: "/solutions" },
      { label: "Employer Branding", href: "/branding" },
      { label: "Campus Recruitment", href: "/campus" },
    ],
  },
  {
    title: "Company",
    links: [
      { label: "About Us", href: "/about" },
      { label: "Careers", href: "/careers" },
      { label: "Press", href: "/press" },
      { label: "Contact Us", href: "/contact" },
      { label: "Partner with Us", href: "/contact" },
    ],
  },
  {
    title: "Resources",
    links: [
      { label: "Help Center", href: "/contact" },
      { label: "Blog", href: "/blog" },
      { label: "Salary Calculator", href: "/salary-calculator" },
      { label: "Job Alerts", href: "/job-alerts" },
      { label: "Disclaimer", href: "/disclaimer" },
      { label: "Sitemap", href: "/sitemap" },
    ],
  },
];
